import {fetchHeaders} from "../../utils/headers";
import Constants from "../../utils/constants";

export const tourneesGraffitiService = {
    fetchTourneesGraffiti,
    fetchTourneeGraffiti,
    deleteTourneeGraffiti,
    createTourneeGraffiti,
    updateTourneeGraffiti,
};

function fetchTourneesGraffiti() {
    const requestOptions = fetchHeaders();
    return fetch(Constants.API_ROUTE_TOURNEES_GRAFFITI, requestOptions)
        .then(handleResponse)
        .then(data => data["hydra:member"]);
}

function fetchTourneeGraffiti(id) {
    const requestOptions = fetchHeaders();
    const url = Constants.API_ROUTE_TOURNEE_GRAFFITI.replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse);
}

function deleteTourneeGraffiti(id) {
    const requestOptions = { ...fetchHeaders(), method: 'DELETE' };
    const url = Constants.API_ROUTE_TOURNEE_GRAFFITI.replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => id);
}

function createTourneeGraffiti(payload) {
    const requestOptions = { ...fetchHeaders(), method: 'POST', headers: { ...fetchHeaders().headers, 'Content-Type': 'application/json' }, body: JSON.stringify(payload) };
    const url = Constants.API_ROUTE_TOURNEES_GRAFFITI;
    return fetch(url, requestOptions).then(handleResponse);
}

function updateTourneeGraffiti(id, payload) {
    const requestOptions = { ...fetchHeaders(), method: 'PATCH', headers: { ...fetchHeaders().headers, 'Content-Type': 'application/merge-patch+json' }, body: JSON.stringify(payload) };
    const url = Constants.API_ROUTE_TOURNEE_GRAFFITI.replace(':id', id);
    return fetch(url, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
